// NOTE: Bu metin bir taslaktır. Hukuki kontrol önerilir.
import LegalPage from "@/components/LegalPage";
import { LEGAL_VERSIONS } from "@/lib/legalVersions";

export default function CookiePolicy() {
  return (
    <LegalPage
      title="Çerez Politikası"
      subtitle="uSeen üzerinde hangi çerezleri kullandığımızı ve bunları nasıl yönetebileceğinizi açıklıyoruz."
      lastUpdated="Mayıs 2026"
      version={LEGAL_VERSIONS.cookies}
      testid="cookie-page"
    >
      <h2>1. Çerez Nedir?</h2>
      <p>
        Çerez, bir web sitesini ziyaret ettiğinizde tarayıcınıza yerleştirilen küçük
        metin dosyalarıdır. Çerezler oturumunuzu hatırlamak, sayfa içi tercihlerinizi
        korumak ve hizmet performansını ölçmek gibi amaçlarla kullanılır.
      </p>

      <h2>2. Kullandığımız Çerez Türleri</h2>

      <h3>Zorunlu çerezler</h3>
      <p>
        Hesabınıza giriş yapabilmeniz, oturumunuzun korunması ve güvenlik kontrollerinin
        yapılabilmesi için kullanılır. Bu çerezler kapatılırsa platform doğru çalışmaz.
      </p>

      <h3>Analitik çerezler</h3>
      <p>
        Hangi sayfalarımızın ne kadar süreyle ziyaret edildiğini, uSeen'in nerelerde
        beklendiği gibi çalıştığını anonim biçimde anlamak için kullanılabilir. Açık
        rıza vermediğiniz sürece bu çerezler etkinleştirilmez.
      </p>

      <h3>Pazarlama çerezleri</h3>
      <p>
        Ürün güncellemelerimiz ve kampanyalarımız için yalnızca açık rıza vermeniz
        hâlinde aktif olur. Bu çerezler, ilgi alanlarınıza uygun iletişim sunabilmek
        için kullanılır.
      </p>

      <h2>3. Çerez Tercihlerini Yönetme</h2>
      <p>
        Tarayıcınızın ayarları üzerinden çerezleri devre dışı bırakabilir, mevcut
        çerezleri silebilir veya çerez kabul edilmeden önce uyarı verilmesini
        sağlayabilirsiniz. Tarayıcı bazında yönergeler için aşağıdaki bağlantıları
        inceleyebilirsiniz:
      </p>
      <ul>
        <li>Google Chrome → Ayarlar → Gizlilik ve Güvenlik → Çerezler ve diğer site verileri</li>
        <li>Mozilla Firefox → Tercihler → Gizlilik ve Güvenlik → Çerezler ve Site Verileri</li>
        <li>Apple Safari → Tercihler → Gizlilik → Çerezleri Yönet</li>
        <li>Microsoft Edge → Ayarlar → Çerezler ve Site İzinleri</li>
      </ul>

      <h2>4. Üçüncü Taraf Çerezler</h2>
      <p>
        Hizmetin sağlanabilmesi için kullanılan bazı altyapı sağlayıcıları (örneğin
        analiz, hata izleme veya CDN servisleri), kendi politikalarına göre çerez
        kullanabilir. uSeen, üçüncü tarafların çerez politikalarından sorumlu değildir;
        ilgili sağlayıcılara ait politikaları kendi sitelerinde inceleyebilirsiniz.
      </p>

      <h2>5. Politikadaki Değişiklikler</h2>
      <p>
        Bu Çerez Politikası, yasal mevzuat veya teknik altyapı değişikliklerine bağlı
        olarak güncellenebilir. Önemli değişikliklerde kullanıcılarımıza bilgi veririz.
      </p>
    </LegalPage>
  );
}
